module.exports = __webpack_public_path__ + "img/upload_indicator.8005222.svg";